"use client";

import HeaderNavbar from "@/components/common/navbar";
import { usePathname } from "next/navigation";
import React, { useMemo } from "react";

export const HeaderLayout = ({ noHeaders }) => {
  const pathname = usePathname();

  const outletRender = useMemo(() => {
    let render = true;
    noHeaders?.map((item) => {
      if (pathname.includes(item)) {
        render = false;
      }
    });

    if (render) {
      return (
        <>
          <HeaderNavbar />
        </>
      );
    }
  }, [pathname, noHeaders]);
  
  return outletRender;
};
